import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
  Stepper,
  Step,
  StepLabel,
  Grid,
  Card,
  CardContent,
  Collapse,
  InputAdornment,
  CardHeader,
  Snackbar,
  FormControlLabel,
  Checkbox
} from '@mui/material';

import { Divider } from '@mui/material';
import Alert from '@mui/material/Alert';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import esLocale from 'date-fns/locale/es';
import ModalConfirmar from './modals/ModalConfirmar.jsx';
import ModalModificar from './modals/ModalModificar.jsx';
import DoneIcon from '@mui/icons-material/Done';
import EventBusyIcon from '@mui/icons-material/EventBusy';

const steps = ['Datos Personales', 'Agendar cita'];


const generateTimeSlots = (selectedDate) => {
  if (!selectedDate) return [];
  const slots = [];
  const addSlot = (hour, min) =>
    slots.push(`${hour.toString().padStart(2, '0')}:${min.toString().padStart(2, '0')}`);
  for (let h = 9; h < 14; h++) { addSlot(h,0); addSlot(h,30); }
  for (let h = 16; h < 18; h++) { addSlot(h,0); addSlot(h,30); }
  return slots;
};


const formatTimeForSQL = (time) => {
  if (!time) return null;
  return time.length === 5 ? `${time}:00` : time;
};



export default function FormSection({refVisita}) {
  const [open, setOpen] = useState(false); 
  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState({ nombre: '', apellidos: '', email: '', telefono: '' });
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState('');
const [errorOpen, setErrorOpen] = useState(false);
const [errorMessage, setErrorMessage] = useState('');

const [occupiedTimes, setOccupiedTimes] = useState([]);
const [diaBloqueado, setDiaBloqueado] = useState(false);


useEffect(() => {
  if (!refVisita || refVisita === "undefined") return;

  const fetchVisitante = async () => {
    try {
      const res = await fetch(
        `/api/visitas/por-ref/${refVisita}`
      );

      if (!res.ok) return;

      const data = await res.json();

      setFormData({
        nombre: data.NOMBRE || '',
        apellidos: data.APELLIDOS || '',
        email: data.EMAIL || '',
        telefono: data.TELEFONO || ''
      });

    } catch (err) {
      console.error('Error cargando refVisita:', err);
    }
  };

  fetchVisitante();
}, [refVisita]);


useEffect(() => {
  if (refVisita) {
    setOpen(true);
    setActiveStep(0);
  }
}, [refVisita]);


useEffect(() => {
  if (!selectedDate) return;

  const fetchOccupied = async () => {
    const fechaStr = selectedDate.toLocaleDateString('en-CA');

    const res = await fetch(`/api/visitas/ocupadas?fecha=${fechaStr}`);
    const data = await res.json();



    if (data.message) {
      setDiaBloqueado(true);       
      setOccupiedTimes([]);       
      return;
    }

    if (Array.isArray(data)) {
      const horasFormateadas = data.map(t => t.slice(0,5));
      setOccupiedTimes(horasFormateadas);
      setDiaBloqueado(false);      
    } else {
      console.error("Respuesta inesperada:", data);
      setOccupiedTimes([]);
      setDiaBloqueado(false);
    }
  };

  fetchOccupied();
}, [selectedDate]);

const [modalOpen, setModalOpen] = useState(false);
const [successOpen, setSuccessOpen] = useState(false);

const handleConfirmModal = async () => {
  try {
    const fechaStr = selectedDate.toLocaleDateString('en-CA');
   const horaStr = selectedTime ? `${selectedTime}:00` : null;

    const res = await fetch('/api/visitas', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...formData,
        fecha: fechaStr,
        hora: horaStr
      }),
    });

    const data = await res.json();

    if (data.error) {
      alert('Error al reservar cita: ' + data.error);
      return;
    }

    setSuccessOpen(true);
    setActiveStep(0);
    setFormData({ nombre: '', apellidos: '', email: '', telefono: '' });
    setSelectedDate(null);
    setSelectedTime('');
    setOccupiedTimes([...occupiedTimes, selectedTime]);
    setModalOpen(false); 

  } catch (err) {
    console.error(err);
    alert('Error al conectar con el servidor');
  }
};


const handleModificarModal = async () => {
  setSuccessOpen(true);
  setActiveStep(0);
  setSelectedDate(null);
  setSelectedTime('');
  setModalOpen(false);
};


const handleNext = () => {
  const { nombre, apellidos, email, telefono } = formData;

  if (!nombre || !apellidos || !email || !telefono) {
    setErrorMessage('Por favor, rellena todos los datos obligatorios');
    setErrorOpen(true);
    return; 
  }

  setActiveStep((prev) => prev + 1); 
};  


  const handleBack = () => setActiveStep((prev) => prev - 1);
  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });


const allSlots = generateTimeSlots(selectedDate);

const morningSlots = allSlots.filter(time => {
  const hour = parseInt(time.split(':')[0]);
  return hour < 14;
});

const afternoonSlots = allSlots.filter(time => {
  const hour = parseInt(time.split(':')[0]);
  return hour >= 16;
});

const [aceptaPrivacidad, setAceptaPrivacidad] = useState(false);




  return (
    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', px: 2, mt: -10, position: 'relative', zIndex: 10 }}>
      
     <Box
  sx={{
    display: 'flex',
    flexDirection: 'column', 
    alignItems: 'center',    
    justifyContent: 'center',
    width: '100%',              
    px: 2
  }}
>

<Snackbar
  open={successOpen}
  autoHideDuration={6000}
  onClose={() => setSuccessOpen(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert
    onClose={() => setSuccessOpen(false)}
    severity="success"
    variant="filled"
    icon={<DoneIcon fontSize="inherit" />}
    sx={{ width: '100%' }}
  >
    Tu solicitud de gestión de visita ha sido realizada con éxito, recibirás un email de confirmación y posteriormente nuestro equipo se pondrá en contacto.
  </Alert>
</Snackbar>


<Snackbar
  open={errorOpen}
  autoHideDuration={4000}
  onClose={() => setErrorOpen(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert
    onClose={() => setErrorOpen(false)}
    severity="error"
    variant="filled"
    sx={{ width: '100%' }}
  >
    {errorMessage}
  </Alert>
</Snackbar>

  <Button
    variant="contained"
    color="error"
    onClick={() => setOpen(!open)}
    sx={{ px: 4, py: 1.5, fontSize: '1rem', mb: 3 }}
  >
    {open ? 'Cerrar Formulario' : 'Reserva cita'}
  </Button>
      
      <Collapse in={open} sx={{ width: '100%' }}>
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center', 
      alignItems: 'center',     
      mt: 2,                   
      mb: 5
    }}
  >
    <Card
      sx={{
        width: '100%',
        maxWidth: 1000,           
        borderRadius: 2,
        border: '1px solid #575757',
        boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
        mt:5
      }}
    >
      <CardHeader
   sx={{
    backgroundColor: '#f5f5f5',
    py: 3,
    boxShadow: '0px 4px 8px rgba(0,0,0,0.2)' 
  }}
  title={
    <Stepper activeStep={activeStep} alternativeLabel>
      {steps.map((label, index) => (
        <Step key={label}>
          <StepLabel
            sx={{
              '& .MuiStepLabel-label': {
                color: activeStep === index ? '#b71c1c' : '#999',
                fontWeight: activeStep === index ? 700 : 400
              },
              '& .MuiStepIcon-root.Mui-active': { color: '#b71c1c' },
              '& .MuiStepIcon-root.Mui-completed': { color: '#b71c1c' }
            }}
          >
            {label}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  }
/>
      <CardContent sx={{mt:2}}>
            {/* PASO 1 */}
        {activeStep === 0 && (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
      gap: 3
    }}
  >
    {/* Nombre */}
    <TextField
      label="Nombre"
      name="nombre"
      value={formData.nombre}
      onChange={handleChange}
      fullWidth
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <PersonIcon />
          </InputAdornment>
        ),
      }}
    required/>

    {/* Apellidos */}
    <TextField
      label="Apellidos"
      name="apellidos"
      value={formData.apellidos}
      onChange={handleChange}
      fullWidth
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <PersonIcon />
          </InputAdornment>
        ),
      }}
    required/>

    {/* Email */}
    <TextField
      label="Email"
      name="email"
      value={formData.email}
      onChange={handleChange}
      fullWidth
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <EmailIcon />
          </InputAdornment>
        ),
      }}
    required/>

    {/* Teléfono */}
   <TextField
  label="Teléfono"
  name="telefono"
  value={formData.telefono}
  onChange={handleChange}
  fullWidth
  type="tel"
  inputProps={{
    pattern: "[0-9]*", 
    maxLength: 9 
  }}
  InputProps={{
    startAdornment: (
      <InputAdornment position="start">
        <PhoneIcon />
      </InputAdornment>
    ),
  }}
required/>

<Box
  sx={{
    gridColumn: { xs: 'span 1', md: 'span 2' },
    display: 'flex',
    justifyContent: 'center'
  }}
>
<Typography
  variant="caption"
  sx={{
    display: "block",
    textAlign: "center",
    mt: 2,
    color: "text.secondary",
    lineHeight: 1.4,
    mx: "auto"
  }}
>
  INFORMACIÓN SOBRE EL TRATAMIENTO DE SUS DATOS PERSONALES <br /> <hr />
  El Responsable del tratamiento de tus datos es la Cámara Oficial de Comercio, Industria y Servicios de Madrid (Q2873001H), 
  que tratará los datos con la finalidad de gestionar tu suscripción y mantenerte informado de productos y servicios de esta Corporación. 
  La legitimación para el tratamiento es el propio consentimiento del usuario y el interés legítimo de la Cámara. 
  No se cederán los datos personales a terceros, salvo obligación legal o indicación expresa. 
  Puede ejercer los derechos de acceso, rectificación, cancelación y oposición, así como el ejercicio de otros derechos, 
  remitiendo un correo electrónico a dpd@camaramadrid.es. 
  Puedes consultar información adicional y detallada sobre la política de privacidad.
</Typography>
</Box>


  <Box
  sx={{
    gridColumn: { xs: 'span 1', md: 'span 2' },
    display: 'flex',
    justifyContent: 'center'
  }}
>
<FormControlLabel
  control={
    <Checkbox
      checked={aceptaPrivacidad}
      onChange={(e) => setAceptaPrivacidad(e.target.checked)}
    />
  }
  label={
    <Typography variant="body2">
      He leído y acepto la{" "}
      <a
        href="https://www.camaramadrid.es/politica-de-privacidad"
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: 'crimson' }}
      >
        política de privacidad
      </a>
    </Typography>
  }
/>

  <Button
  variant="contained"
  color="error"
  onClick={handleNext}
  disabled={!aceptaPrivacidad}
>
  Siguiente
  <NavigateNextIcon />
</Button>
</Box>
  </Box>
)}

       {/* PASO 2 */}
{activeStep === 1 && (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, alignItems: 'center' }}>
    <LocalizationProvider
  dateAdapter={AdapterDateFns}
  adapterLocale={esLocale}
>
  <DatePicker
    label="Selecciona un día"
    value={selectedDate}
    inputFormat="dd/MM/yyyy"
    mask="__/__/____"
    onChange={(newDate) => {
      if (!newDate || isNaN(newDate)) {
        setSelectedDate(null);
        return;
      }

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const currentDate = new Date(newDate);
      currentDate.setHours(0, 0, 0, 0);

      const day = currentDate.getDay();

      const isPast = currentDate < today;
      const isWeekendOrFriday =
        day === 0 || day === 5 || day === 6;

      // Si es inválida NO la guardamos
      if (isPast || isWeekendOrFriday) {
        setSelectedDate(null);
        setSelectedTime('');
        return;
      }

      setSelectedDate(currentDate);
      setSelectedTime('');
    }}
    shouldDisableDate={(date) => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const currentDate = new Date(date);
      currentDate.setHours(0, 0, 0, 0);

      const day = currentDate.getDay();

      const isPast = currentDate < today;
      const isWeekendOrFriday =
        day === 0 || day === 5 || day === 6;

      return isPast || isWeekendOrFriday;
    }}
    renderInput={(params) => (
      <TextField
        {...params}
        sx={{ width: 250 }}
      />
    )}
  />
</LocalizationProvider>


{selectedDate && (
  <Box sx={{ mt: 2, width: '100%', maxWidth: 700 }}>

    {diaBloqueado ? (
     <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
  <EventBusyIcon sx={{ color: 'crimson', fontSize: 30 }} />

  <Divider orientation="vertical" flexItem sx={{ borderColor: '#d3d3d3' }} />

  <Typography
    sx={{
      fontWeight: 600,
      fontSize: '1.1rem',
      textAlign: 'center',
      color: 'crimson'
    }}
  >
    No hay citas disponibles para la fecha seleccionada.
    <br />
    Por favor, elija otro día para gestionar su visita.
  </Typography>
</Box>

    ) : (
      <>
        {/* MAÑANA */}
        {morningSlots.length > 0 && (
          <>
            <Typography sx={{ mb: 1, fontWeight: 600 }}>Mañana</Typography>
            <hr />
            <Grid container spacing={2} sx={{ mb: 2 }}>
        {morningSlots.map(time => {
          const isOccupied = occupiedTimes.includes(time);

          return (
            <Grid item xs={4} key={time}>
              <Button
                fullWidth
                disabled={isOccupied}
                variant={selectedTime === time ? 'contained' : 'outlined'}
                onClick={() => !isOccupied && setSelectedTime(time)}
                sx={{
                  borderColor: '#b71c1c',
                  color: isOccupied
                    ? '#999'
                    : selectedTime === time
                    ? '#fff'
                    : '#9c0505',
                  backgroundColor: isOccupied
                    ? '#d3d3d3'
                    : selectedTime === time
                    ? '#b71c1c'
                    : '#fff',
                  opacity: isOccupied ? 0.6 : 1,
                  cursor: isOccupied ? 'not-allowed' : 'pointer'
                }}
              >
                {time}
              </Button>
            </Grid>
             );
        })}
            </Grid>
          </>
        )}

        {/* TARDE */}
        {afternoonSlots.length > 0 && (
          <>
            <Typography sx={{ mb: 1, fontWeight: 600 }}>Tarde</Typography>
            <hr />
            <Grid container spacing={2}>
               {afternoonSlots.map(time => {
          const isOccupied = occupiedTimes.includes(time);

          return (
            <Grid item xs={4} key={time}>
              <Button
                fullWidth
                disabled={isOccupied}
                variant={selectedTime === time ? 'contained' : 'outlined'}
                onClick={() => !isOccupied && setSelectedTime(time)}
                sx={{
                  borderColor: '#b71c1c',
                  color: isOccupied
                    ? '#999'
                    : selectedTime === time
                    ? '#fff'
                    : '#9c0505',
                  backgroundColor: isOccupied
                    ? '#d3d3d3'
                    : selectedTime === time
                    ? '#b71c1c'
                    : '#fff',
                  opacity: isOccupied ? 0.6 : 1,
                  cursor: isOccupied ? 'not-allowed' : 'pointer'
                }}
              >
                {time}
              </Button>
            </Grid>
          );
        })}
            </Grid>
          </>
        )}
      </>
    )}

  </Box>
)}


    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 4, mt: 3 }}>
      <Button variant='outlined' color='error' onClick={handleBack}>
        <ArrowBackIosIcon /> Atrás
      </Button>
      <Button
  variant="contained"
  color="error"
  disabled={!selectedTime}
  onClick={() => setModalOpen(true)}
>
  Confirmar cita
</Button>


{refVisita ? (
  <ModalModificar
    open={modalOpen}
    handleClose={() => setModalOpen(false)}
    formData={formData}
    fecha={selectedDate ? selectedDate.toLocaleDateString('es-ES') : ''}
    hora={selectedTime}
    refVisita={refVisita}
    onConfirm={handleModificarModal}
  />
) : (
  <ModalConfirmar
    open={modalOpen}
    handleClose={() => setModalOpen(false)}
    formData={formData}
    fecha={selectedDate ? selectedDate.toLocaleDateString('es-ES') : ''}
    hora={selectedTime}
    onConfirm={handleConfirmModal}
  />
)}
    </Box>
  </Box>
)}
          </CardContent>
        </Card>
        </Box>
      </Collapse>
</Box>
    </Box>
  );
}